import React, { useState } from 'react';
import { Card, Grid, Table, Button } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useCallback } from 'react';
import { useQuery } from 'react-query';

import { getColumns } from './columns';
import { getTeamMembers } from 'api/teams';
import { paths } from 'configs/paths';
import UserView from './UserView';
import { TemplateUtils as utils } from 'utils/templateUtils';

const { useBreakpoint } = Grid;
const { getBreakPoint } = utils;

const MembersList = _ => {
  const { teamId, tournamentId } = useParams();
  const { push } = useHistory();
  const [userProfileVisible, setUserProfileVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const screens = getBreakPoint(useBreakpoint());
  const isMobile = !screens.includes('lg');
  const {
    state: { clubName, adminId },
  } = useLocation();

  const showUserProfile = userInfo => {
    setUserProfileVisible(true);
    setSelectedUser(userInfo);
  };

  const closeUserProfile = () => {
    setUserProfileVisible(false);
    setSelectedUser(null);
  };

  const resolver = useCallback(async (_, _tournamentId, _teamId) => {
    const { body } = await getTeamMembers(_tournamentId, _teamId);

    return body?.data || [];
  }, []);

  const { data, isLoading } = useQuery(['team-members', tournamentId, teamId], resolver);

  const getTeamAdmin = () => {
    const admin = data?.filter(({ club_member: { user } }) => user.id === adminId);
    return admin?.length === 1
      ? `${admin[0]?.club_member.user.first_name} ${admin[0]?.club_member.user.last_name}`
      : '';
  };

  const responsiveStyles = {
    headerContainer: isMobile ? 'flex flex-col pb-4' : 'flex items-center justify-between pb-4',
    labelsContainer: isMobile ? 'flex-col pb-4' : 'flex',
    adminLabel: isMobile ? 'block pt-2' : 'ml-4',
  };

  return (
    <Card
      title={
        <div className={responsiveStyles.headerContainer}>
          <div className={responsiveStyles.labelsContainer}>
            <TeamOutlined /> : {clubName}
            <span className={responsiveStyles.adminLabel}>Administrador: {getTeamAdmin()}</span>
          </div>
          <Button
            type="primary"
            className="ml-4"
            onClick={() => push(paths.event.lineupRequest(teamId, tournamentId))}
          >
            Solicitud de nuevo miembro
          </Button>
        </div>
      }
      bodyStyle={{ padding: '0px' }}
    >
      <Table
        columns={getColumns(showUserProfile)}
        dataSource={data}
        rowKey={obj => obj.id}
        loading={isLoading}
      />
      <UserView
        data={selectedUser}
        visible={userProfileVisible}
        close={() => {
          closeUserProfile();
        }}
      />
    </Card>
  );
};
export default MembersList;
